import { LogoPaypal } from './LogoPaypal'

export default LogoPaypal
